import Breadcrumb from '../../components/common/Breadcrumb'
import styled from '@emotion/styled'
import HepatitisForm from './HepatitisForm'
import { useRouter } from '../../utils/helper'
import { useGetHepatitisById } from '../../services/hepatitis/hepatitis-query'
import HepatitisInfo from './HepatitisInfo'
import Loading from '../../components/common/Loading'
import { hepatitis, hepatitisDetail, enrollment, home } from '../../constant/path'
import { mobile, useScreen } from '../../utils/responsive-helper'
import { useMemo } from 'react'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux-store'
import { HepatitisInfoWithConcentDate, HepatitisInfoWithoutConcentDate } from '../../redux-store/hepatitis-reducer'
import color from '../../constant/colors'

const BackgroundHeader = styled.div`
  background-color: ${color.CHOICES_PRIMARY};
  width: calc(100% - 32px);
  height: 266px;
  margin-top: 0px !important;
  position: absolute;

  ${mobile} {
    width: 100%;
  }
`
const Layout = styled.div`
  width: 768px;
  margin: 0 auto;
  z-index: 1;
  > * {
    margin-top: 24px;
  }

  ${mobile} {
    width: 100%;
  }
`

const HepatitisDetail = () => {
  const { query } = useRouter<{ hepatitisId: number, claimTypeId: string, isCreateNew: 'true' | 'false' }>()

  const { isMobile } = useScreen()
  const { data: hepatitisItem, isLoading } = useGetHepatitisById({ claimId: query.hepatitisId })
  const initialValue = useMemo(() => { return { relativeTypeId: 0, } }, [])
  const hepatitisFormValue = useSelector((state: RootState) => state.hepatitis.claimInfo) as HepatitisInfoWithConcentDate & HepatitisInfoWithoutConcentDate

  const isCreateNew = useMemo(() => {
    return query.isCreateNew === 'true'
  }, [query.isCreateNew])

  return (
    <Loading loading={false}>
      <BackgroundHeader />
      <Layout>
        <Headbar title={hepatitisItem?.name || ''} backWard={paths.hepatitis()} />
        {/* <HepatitisInfo hepatitisItem={hepatitisItem} /> */}

        {/*   <HepatitisDocument /> */}

        <HepatitisForm hepatitisItem={hepatitisItem} hepatitisFormValue={hepatitisFormValue} allpayStatus={false} hepatitisId={query.hepatitisId} isCreateNew={isCreateNew} />
      </Layout>
    </Loading>
  )
}

export default HepatitisDetail
